/** @format */

import * as yup from 'yup';

const validationSchema = (t) =>
  yup.object({
    name: yup.string(t('invoicing.invoiceVendorForm.validation.name')).required(t('common.required')),
    isActive: yup.boolean().required(t('common.required')),
    statusUrl: yup.string(),
    vendorType: yup.string(t('invoicing.invoiceVendorForm.validation.vendorType')).required(t('common.required')),
    vat: yup.string(t('invoicing.invoiceVendorForm.validation.vat')).required(t('common.required')),
    shopId: yup.string(t('invoicing.invoiceVendorForm.validation.shopId')).required(t('common.required')),
    vatNumber: yup
      .string(t('invoicing.invoiceVendorForm.validation.vatNumber'))
      .matches(/^[0-9]{8}[-][0-9][-][0-9]{2}$/, t('invoicing.invoiceVendorForm.validation.vatNumberFormat'))
      .required(t('common.required')),
    country: yup.string(t('invoicing.invoiceVendorForm.validation.country')).required(t('common.required')),
    city: yup.string(t('invoicing.invoiceVendorForm.validation.city')).required(t('common.required')),
    zipcode: yup.string(t('invoicing.invoiceVendorForm.validation.zipcode')).required(t('common.required')),
    street: yup.string(t('invoicing.invoiceVendorForm.validation.street')).required(t('common.required')),
    streetNo: yup.string(t('invoicing.invoiceVendorForm.validation.streetNo')).required(t('common.required')),
    bankName: yup.string(t('invoicing.invoiceVendorForm.validation.bankName')).required(t('common.required')),
    accountNumber: yup
      .string(t('invoicing.invoiceVendorForm.validation.accountNumber'))
      .matches(
        /^[0-9]{8}[-][0-9]{8}[-][0-9]{8}$|^[0-9]{8}[-][0-9]{8}$|^[0-9]{16}$|^[0-9]{24}$/,
        t('invoicing.invoiceVendorForm.validation.accountNumberFormat')
      )
      .max(26, t('invoicing.invoiceVendorForm.validation.accountNumberMax'))
      .required(t('common.required')),
    iban: yup.string(t('invoicing.invoiceVendorForm.validation.iban')).required(t('common.required')),
    clientId: yup.string(t('invoicing.invoiceVendorForm.validation.clientId')).required(t('common.required')),
    clientSecret: yup.string(t('invoicing.invoiceVendorForm.validation.clientSecret')).required(t('common.required'))
  });

export default validationSchema;
